const mimeTypes: Record<string, string> = {
  'video/x-msvideo': 'avi',
  'image/bmp': 'bmp',
  'image/gif': 'gif',
  'video/x-flv': 'flv',
  'image/x-freehand': 'fh4',
  'image/x-icon': 'ico',
  'image/jpeg': 'jpg',
  'image/jpg': 'jpg',
  'video/quicktime': 'mov',
  'video/mpeg': 'mpeg',
  'image/png': 'png',
  'image/tiff': 'tiff',
  'video/x-mpg': 'vob',
};

export default mimeTypes;
